var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _vm._l(_vm.$v.contact.woonplaats.$each.$iter, function(plaats, index) {
        return _c("address-input", {
          key: "wp-" + index,
          attrs: {
            id: "plaats-" + index,
            label:
              _vm.contact.woonplaats.length != 1
                ? _vm.labels.woonplaats.objectName.singular +
                  " " +
                  (parseInt(index) + 1)
                : _vm.labels.woonplaats.objectName.singular,
            "is-new": index >= _vm.cache.woonplaats.length,
            "is-dirty": _vm.isDiffToCache(
              _vm.contact.woonplaats[parseInt(index)],
              _vm.cache.woonplaats[parseInt(index)]
            ),
            "show-delete": index != 0,
            info: _vm.infoForInput("woonplaats"),
            "is-disabled": _vm.disabledFieldsMap.woonplaats
          },
          on: {
            "delete-address": function($event) {
              return _vm.deleteWoonplaats(index)
            }
          },
          model: {
            value: _vm.contact.woonplaats[index],
            callback: function($$v) {
              _vm.$set(_vm.contact.woonplaats, index, $$v)
            },
            expression: "contact.woonplaats[index]"
          }
        })
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-center my-1 pb-3 border-bottom" },
        [
          _vm.hasMaxOneNew(_vm.contact.woonplaats, _vm.cache.woonplaats)
            ? _c("plus-button", {
                attrs: {
                  disabled: _vm.disabledFieldsMap.woonplaats,
                  label:
                    "Bij verhuis: " +
                    _vm.labels.woonplaats.objectName.singular.toLowerCase() +
                    " toevoegen"
                },
                on: {
                  click: function($event) {
                    return _vm.addWoonplaats()
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.$v.contact.verblijfplaats.$each.$iter, function(
        plaats,
        index
      ) {
        return _c("address-input", {
          key: "vp-" + index,
          staticClass: "mt-3",
          attrs: {
            id: "verblijfplaats-" + index,
            label:
              _vm.contact.verblijfplaats.length != 1
                ? _vm.labels.verblijfplaats.objectName.singular +
                  " " +
                  (parseInt(index) + 1)
                : _vm.labels.verblijfplaats.objectName.singular,
            "is-dirty": _vm.isDiffToCache(
              _vm.contact.verblijfplaats[parseInt(index)],
              _vm.cache.verblijfplaats[parseInt(index)]
            ),
            "show-delete": index != 0,
            "is-new": index >= _vm.cache.verblijfplaats.length,
            info: _vm.infoForInput("verblijfplaats"),
            "is-disabled": _vm.disabledFieldsMap.verblijfplaats
          },
          on: {
            "delete-address": function($event) {
              return _vm.deleteVerblijfplaats(index)
            }
          },
          model: {
            value: _vm.contact.verblijfplaats[index],
            callback: function($$v) {
              _vm.$set(_vm.contact.verblijfplaats, index, $$v)
            },
            expression: "contact.verblijfplaats[index]"
          }
        })
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-center my-1 pb-3 border-bottom" },
        [
          _vm.hasMaxOneNew(_vm.contact.verblijfplaats, _vm.cache.verblijfplaats)
            ? _c("plus-button", {
                staticClass: "mr-1",
                attrs: {
                  disabled: _vm.disabledFieldsMap.verblijfplaats,
                  label:
                    "Bij verhuis: " +
                    _vm.labels.verblijfplaats.objectName.singular.toLowerCase() +
                    " toevoegen"
                },
                on: {
                  click: function($event) {
                    return _vm.addVerblijfplaats()
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isWoonplaatsVerhuisAdded &&
          _vm.hasMaxOneNew(_vm.contact.verblijfplaats, _vm.cache.verblijfplaats)
            ? _c("plus-button", {
                attrs: {
                  disabled: _vm.disabledFieldsMap.verblijfplaats,
                  label:
                    "Nieuwe " +
                    _vm.labels.woonplaats.objectName.singular.toLowerCase() +
                    " overnemen"
                },
                on: {
                  click: function($event) {
                    return _vm.contact.verblijfplaats.push(
                      _vm.contact.woonplaats[1]
                    )
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.$v.contact.correspondentie.$each.$iter, function(
        plaats,
        index
      ) {
        return _c("address-input", {
          key: "corr-" + index,
          staticClass: "mt-3",
          attrs: {
            id: "correspondentie-" + index,
            label:
              _vm.contact.correspondentie.length != 1
                ? _vm.labels.correspondentie.objectName.singular +
                  " " +
                  (parseInt(index) + 1)
                : _vm.labels.correspondentie.objectName.singular,
            "is-dirty": _vm.isDiffToCache(
              _vm.contact.correspondentie[parseInt(index)],
              _vm.cache.correspondentie[parseInt(index)]
            ),
            "show-delete": index != 0,
            "is-new": index >= _vm.cache.correspondentie.length,
            info: _vm.infoForInput("correspondentie"),
            "is-disabled": _vm.disabledFieldsMap.correspondentie
          },
          on: {
            "delete-address": function($event) {
              return _vm.deleteCorrespondentie(index)
            }
          },
          model: {
            value: _vm.contact.correspondentie[index],
            callback: function($$v) {
              _vm.$set(_vm.contact.correspondentie, index, $$v)
            },
            expression: "contact.correspondentie[index]"
          }
        })
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-center my-1 pb-3 border-bottom" },
        [
          _vm.hasMaxOneNew(
            _vm.contact.correspondentie,
            _vm.cache.correspondentie
          )
            ? _c("plus-button", {
                staticClass: "mr-1",
                attrs: {
                  disabled: _vm.disabledFieldsMap.correspondentie,
                  label:
                    "Bij verhuis: " +
                    _vm.labels.correspondentie.objectName.singular.toLowerCase() +
                    " toevoegen"
                },
                on: {
                  click: function($event) {
                    return _vm.addCorrespondentie()
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isWoonplaatsVerhuisAdded &&
          _vm.hasMaxOneNew(
            _vm.contact.correspondentie,
            _vm.cache.correspondentie
          )
            ? _c("plus-button", {
                attrs: {
                  disabled: _vm.disabledFieldsMap.correspondentie,
                  label:
                    "Nieuwe " +
                    _vm.labels.woonplaats.objectName.singular.toLowerCase() +
                    " overnemen"
                },
                on: {
                  click: function($event) {
                    return _vm.contact.correspondentie.push(
                      _vm.contact.woonplaats[1]
                    )
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.$v.contact.comnummer.$each.$iter, function(nummer, index) {
        return _c("phone-input", {
          key: "PhoneNr-" + index,
          staticClass: "mt-3",
          attrs: {
            id: "nr-" + index,
            label:
              _vm.contact.comnummer.length != 1
                ? _vm.labels.comnummer.objectName.singular +
                  " " +
                  (parseInt(index) + 1)
                : _vm.labels.comnummer.objectName.singular,
            "is-new": index >= _vm.cache.comnummer.length,
            "is-dirty": _vm.isDiffToCache(
              _vm.contact.comnummer[parseInt(index)],
              _vm.cache.comnummer[index]
            ),
            info: _vm.infoForInput("comnummer"),
            "show-delete": _vm.contact.comnummer.length > 1,
            "is-disabled": _vm.disabledFieldsMap.comnummer
          },
          on: {
            "delete-phone": function($event) {
              return _vm.deleteTelefoonNummer(index)
            }
          },
          model: {
            value: _vm.contact.comnummer[index],
            callback: function($$v) {
              _vm.$set(_vm.contact.comnummer, index, $$v)
            },
            expression: "contact.comnummer[index]"
          }
        })
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-center my-3 pb-3 border-bottom" },
        [
          _c("plus-button", {
            attrs: {
              label: "Telefoon-, GSM- of noodnummer toevoegen",
              disabled: _vm.disabledFieldsMap.comnummer
            },
            on: {
              click: function($event) {
                return _vm.addTelefoonNummer()
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.$v.contact.email.$each.$iter, function(email, index) {
        return _c("mail-input", {
          key: index,
          staticClass: "mt-3",
          attrs: {
            id: "pLidEmail" + index,
            label:
              _vm.contact.email.length != 1
                ? _vm.labels.email.objectName.singular +
                  " " +
                  (parseInt(index) + 1)
                : _vm.labels.email.objectName.singular,
            "is-dirty": _vm.isDiffToCache(
              _vm.contact.email[parseInt(index)],
              _vm.cache.email[parseInt(index)]
            ),
            "is-new": parseInt(index) >= _vm.cache.email.length,
            "show-delete": index != 0,
            info: _vm.infoForInput("email"),
            "is-disabled": _vm.disabledFieldsMap.email
          },
          on: {
            "delete-mail": function($event) {
              return _vm.deleteEmail(index)
            }
          },
          model: {
            value: _vm.contact.email[index].emailAdres,
            callback: function($$v) {
              _vm.$set(_vm.contact.email[index], "emailAdres", $$v)
            },
            expression: "contact.email[index].emailAdres"
          }
        })
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-center my-2" },
        [
          _c("plus-button", {
            attrs: {
              disabled: _vm.disabledFieldsMap.email,
              label: "E-mailadres toevoegen"
            },
            on: {
              click: function($event) {
                return _vm.addEmail()
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pt-3 mt-3 border-top" },
        _vm._l(_vm.$v.contact.werkEmail.$each.$iter, function(email, index) {
          return _c("text-input", {
            key: "werkEmail-" + index,
            attrs: {
              id: "werkEmail-" + index,
              label:
                _vm.contact.werkEmail.length != 1
                  ? _vm.labels.werkEmail.objectName.singular +
                    " " +
                    (parseInt(index) + 1)
                  : _vm.labels.werkEmail.objectName.singular,
              "validation-object": _vm.$v.contact.werkEmail,
              info: _vm.infoForInput("werkEmail"),
              "is-dirty": false,
              "is-disabled": _vm.disabledFieldsMap.werkEmail
            },
            model: {
              value: _vm.contact.werkEmail[index].emailAdres,
              callback: function($$v) {
                _vm.$set(_vm.contact.werkEmail[index], "emailAdres", $$v)
              },
              expression: "contact.werkEmail[index].emailAdres"
            }
          })
        }),
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "pt-2 mt-3 border-top" }, [
        _c("label", { staticClass: "font-weight-bold" }, [
          _vm._v("Opmerking:")
        ]),
        _vm._v(" "),
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.currentRemark,
              expression: "currentRemark"
            }
          ],
          staticClass: "form-control mb-2",
          attrs: { rows: "3", placeholder: "Opmerking", type: "text" },
          domProps: { value: _vm.currentRemark },
          on: {
            input: [
              function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.currentRemark = $event.target.value
              },
              _vm.onRemarkChange
            ]
          }
        })
      ]),
      _vm._v(" "),
      _c("file-upload", {
        attrs: { label: "Bewijsstuk(ken) uploaden:", "upload-percentage": 0 },
        on: { "files-changed": _vm.onFilesChanged }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }